import { render, staticRenderFns } from "./FinalPutOnHoldModal.vue?vue&type=template&id=212e1ac1"
import script from "./FinalPutOnHoldModal.vue?vue&type=script&lang=js"
export * from "./FinalPutOnHoldModal.vue?vue&type=script&lang=js"
import style0 from "./FinalPutOnHoldModal.vue?vue&type=style&index=0&id=212e1ac1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports